import React from 'react';
import styles from './Label.css';
import classNames from 'classnames';

interface IExtensionLabelProps extends React.ComponentPropsWithoutRef<'div'> {
  text: string;
  size?: 'XS';
  theme?: 'success' | 'warning';
}

const LabelComponent = React.forwardRef(function Label(
  { text, theme, size, ...rest }: IExtensionLabelProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div ref={ref} className={classNames(styles['label'], theme && styles[theme], size && styles[size])} {...rest}>
      {text}
    </div>
  );
});

export const Label = React.memo(LabelComponent);
